import { useEffect } from "react";
import { useGuidesContext } from "./Guides";

export default function GuideQuickTips(props: { className ?: string, onCancel: () => void}){
    const { className = '', onCancel } = props ;

    const guidesContext = useGuidesContext();

    const change = (model : string) => {
        guidesContext?.changeModel(model);
        onCancel();
    }

    const hideController = () => {
        // onCancel();
    }
    useEffect(() => {
        window.addEventListener('click', hideController);
        return () => {
            window.removeEventListener('click', hideController);
        }
    },[])

    return (
        <div className={`absolute bg-[#FFFFFF] w-[160px] z-[999999] rounded-[10px] shadow-box flex flex-col ${className}`}>
            <p className="color-[#000000] text-[14px] font-[500] p-[10px] text-center">Guide</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-left hover:bg-[#D9F2FF]"
                onClick={() => change('mockup')}>Generate Mockups</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-left hover:bg-[#D9F2FF]"
                onClick={() => change('template')}>Use Mockup Templates</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-left hover:bg-[#D9F2FF]"
                onClick={() => change('color')}>Change Product Colors</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-left hover:bg-[#D9F2FF]"
                onClick={() => change('aop')}>AOP Design</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-left hover:bg-[#D9F2FF]"
                onClick={() => change('text')}>Text Design</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-left hover:bg-[#D9F2FF] rounded-b-[10px]"
                onClick={() => change('rasterize')}>Rasterize Mockup</p>
            {/* <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-center hover:bg-[#D9F2FF]"
                onClick={() => change('removebg')}>removeBg</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-center hover:bg-[#D9F2FF]"
                onClick={() => change('upscale')}>upscale</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-center hover:bg-[#D9F2FF]"
                onClick={() => change('eraser')}>eraser</p>
            <p className="color-[#000000] text-[12px] cursor-pointer p-[10px] text-center hover:bg-[#D9F2FF]"
                onClick={() => change('ai-image')}>ai-image</p> */}
        </div>
    )
}